// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__IdUBf button, .style_pagination__IdUBf div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__akO-N {
  display: flex;
  align-items: center;
}

.style_container_fields_actions__7LzFa {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.style_interface_noResults__iamwN {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_container_fields__dIIaD, .style_interface__9yc51 {
  display: flex;
  flex-direction: column;
}

.style_container_fields_actions__7LzFa {
  display: flex;
  align-items: flex-start;
}

a {
  text-decoration: none;
}

.style_link__2MFbX {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__2MFbX:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__o\\+kAT {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__WFoas {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__x-48N, .style_interface_heading__hPMJY, .style_interface_footer__yI8m7 {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__XqD2Z {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__ySmpK {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__ySmpK {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__Ny5me {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__Ny5me {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__8BN4\\+ {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__8BN4\\+ {
    line-height: 1.5rem;
  }
}

.style_breadcumb__Umiqk {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__Umiqk a,
.style_breadcumb__Umiqk span {
  padding: 3px 5px;
}
.style_breadcumb__Umiqk a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__Umiqk a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__Umiqk .style_divider__L9PlY {
  color: var(--color-gray-400);
}

.style_badge__zaKJ- {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__zaKJ-.style_xs__AzKov {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__zaKJ-.style_sm__0a\\+9H {
  padding: 4px 7px;
}
.style_badge__zaKJ-.style_primary__tWUd9 {
  background: var(--color-primary-500);
}
.style_badge__zaKJ-.style_primary__tWUd9, .style_badge__zaKJ-.style_pm__DVrQh {
  background: var(--color-primary-500);
}
.style_badge__zaKJ-.style_sd__\\+z0QT {
  background-color: var(--color-secundary-500);
}
.style_badge__zaKJ-.style_Likely__juAhP {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__zaKJ-.style_Unvalidated__NAZEI {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__zaKJ-.style_Verified__IPic\\+, .style_badge__zaKJ-.style_green__TmRpn {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__zaKJ-.style_off__ALPA- {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__M5T16 {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__M5T16.style_xs__AzKov {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__M5T16.style_sm__0a\\+9H {
  padding: 4px 7px;
}
.style_badgeTable__M5T16.style_primary__tWUd9, .style_badgeTable__M5T16.style_pm__DVrQh {
  background: var(--color-primary-500);
}
.style_badgeTable__M5T16.style_sd__\\+z0QT {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__M5T16.style_Likely__juAhP {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__M5T16.style_Verified__IPic\\+, .style_badgeTable__M5T16.style_green__TmRpn {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__M5T16.style_off__ALPA- {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__B6epK {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__B6epK.style_style-1__i6woY td,
.style_table__B6epK.style_style-1__i6woY th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__B6epK.style_style-1__i6woY th,
.style_table__B6epK.style_style-1__i6woY td.style_label__2H\\+qg {
  color: var(--color-white-500);
}
.style_table__B6epK.style_style-1__i6woY th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__B6epK.style_style-1__i6woY tr.style_noBorder__QwxU4 td {
  border-bottom: none;
}
.style_table__B6epK.style_style-1__i6woY tr td {
  color: var(--color-white-500);
}

.style_pagination__IdUBf {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__IdUBf button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__IdUBf button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__IdUBf button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__IdUBf button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__IdUBf button.style_disabled__r8uIk, .style_pagination__IdUBf button.style_active__n2JD5, .style_pagination__IdUBf button.style_info__0wzeD {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__IdUBf button.style_disabled__r8uIk {
  color: var(--color-gray-700);
}
.style_pagination__IdUBf div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__IdUBf div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__IdUBf div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__IdUBf div:hover, .style_pagination__IdUBf div.style_active__n2JD5 {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__IdUBf div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__IdUBf div.style_disabled__r8uIk, .style_pagination__IdUBf div.style_active__n2JD5, .style_pagination__IdUBf div.style_info__0wzeD {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__IdUBf div.style_disabled__r8uIk {
  color: var(--color-gray-700);
}
.style_pagination__IdUBf div:last-child, .style_pagination__IdUBf div:first-child {
  padding: 0 10px;
}
.style_pagination__IdUBf div:last-child {
  border-right: none;
}
.style_pagination__IdUBf button:last-child, .style_pagination__IdUBf button:first-child {
  padding: 0 10px;
}
.style_pagination__IdUBf button:last-child {
  border-right: none;
}

.style_interface__9yc51 {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__hPMJY {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__hPMJY {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__hPMJY > div {
    width: 100%;
  }
}
.style_interface_heading_row__akO-N {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__akO-N {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__yI8m7 {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__yI8m7 {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__yI8m7 > div {
    width: 100%;
  }
}
.style_interface_foot__Pxu5p {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__Pxu5p {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__iamwN {
  gap: 15px;
  padding: 70px 0;
}

.style_main__soj\\+g {
  background-color: var(--dark-bg);
  padding: 24px;
  border-radius: 8px;
}
@media only screen and (max-width: 780px) {
  .style_main__soj\\+g {
    width: 100%;
    padding: 0;
    background-color: transparent;
  }
}

.style_container_fields__dIIaD {
  background-color: var(--dark-bg);
  gap: 20px;
  padding: 25px;
  border-radius: 8px;
}
.style_container_fields_actions__7LzFa {
  gap: 20px;
  margin-top: 0.75rem;
}
.style_container_fields_actions__7LzFa button {
  width: max-content;
}
.style_container_fields_actions__7LzFa button:hover:not([disabled]) {
  background: linear-gradient(var(--main-color), rgba(0, 0, 0, 0.7)) top/100% 900%;
}
@media only screen and (max-width: 780px) {
  .style_container_fields_actions__7LzFa button {
    width: 100%;
  }
  .style_container_fields__dIIaD {
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/components/molecules/SubscriptionInfo/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADOA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;ACJF;;ADOA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACJF;;ADuBA;EACE,aAAA;EACA,sBAAA;ACpBF;;AD0DA;EACE,aAAA;EACA,uBAAA;ACvDF;;ACxBA;EACI,qBAAA;AD2BJ;;ACzBA;EACI,eAAA;EACA,cAAA;AD4BJ;AC3BI;EACE,0BAAA;AD6BN;;ACzBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AD4BJ;;ACzBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;AD4BR;AC1BI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;AD4BR;AC1BI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;AD4BR;AC1BI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AD4BR;AEpEE;EDsCE;IAIQ,eAAA;IACA,mBAAA;ED8BV;AACF;AC5BI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AD8BR;AE9EE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EDgCV;AACF;AC9BI;EACI,mBAAA;ADgCR;AEvFE;EDsDE;IAGQ,mBAAA;EDkCV;AACF;;AG1FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AH6FF;AG5FE;;EAEE,gBAAA;AH8FJ;AG5FE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AH8FJ;AG7FI;EACE,+BAAA;EACA,uCAAA;AH+FN;AG5FE;EACE,4BAAA;AH8FJ;;AIlHA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJqHF;AIlHE;EACE,gBAAA;EACA,eAAA;AJoHJ;AIlHE;EACE,gBAAA;AJoHJ;AIhHE;EACE,oCAAA;AJkHJ;AIhHE;EAEE,oCAAA;AJiHJ;AI/GE;EACE,4CAAA;AJiHJ;AI/GE;EACE,uCAAA;EACA,mCAAA;AJiHJ;AI/GE;EACE,oCAAA;EACA,gCAAA;AJiHJ;AI/GE;EAEE,4CAAA;EACA,kCAAA;AJgHJ;AI9GE;EACE,6BAAA;EACA,uCAAA;AJgHJ;;AI7GA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJgHF;AI7GE;EACE,gBAAA;EACA,eAAA;AJ+GJ;AI7GE;EACE,gBAAA;AJ+GJ;AI3GE;EAEE,oCAAA;AJ4GJ;AI1GE;EACE,4CAAA;AJ4GJ;AI1GE;EACE,mBAAA;EACA,cAAA;AJ4GJ;AI1GE;EAEE,4CAAA;EACA,kCAAA;AJ2GJ;AIzGE;EACE,6BAAA;EACA,uCAAA;AJ2GJ;;AKnMA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ALsMF;AKpMI;;EAEE,kBAAA;EACA,mBAAA;ALsMN;AKpMI;;EAEE,6BAAA;ALsMN;AKpMI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ALsMN;AKnMM;EACE,mBAAA;ALqMR;AKnMM;EACE,6BAAA;ALqMR;;AMzNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;AN2NJ;AMzNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;AN0NR;AMzNQ;EACI,2BAAA;EACA,8BAAA;AN2NZ;AMzNQ;EACI,4BAAA;EACA,+BAAA;AN2NZ;AE1PE;EIgBE;IAkBQ,eAAA;IACA,eAAA;EN4NV;AACF;AM3NQ;EACI,eAAA;EACA,oBAAA;AN6NZ;AM3NQ;EACI,4BAAA;AN6NZ;AM1NI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;AN2NR;AM1NQ;EACI,2BAAA;EACA,8BAAA;AN4NZ;AM1NQ;EACI,4BAAA;EACA,+BAAA;AN4NZ;AM1NQ;ECrCJ,eAAA;EACA,qFAAA;APkQJ;AE5RE;EI6CE;IAqBQ,eAAA;IACA,eAAA;EN8NV;AACF;AM7NQ;EACI,eAAA;EACA,oBAAA;AN+NZ;AM7NQ;EACI,4BAAA;AN+NZ;AM5NI;EACI,eAAA;AN8NR;AM5NI;EACI,kBAAA;AN8NR;AM5NI;EACI,eAAA;AN8NR;AM5NI;EACI,kBAAA;AN8NR;;AQhTA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ARmTF;AQjTE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARkTJ;AE1UE;EMeA;IAWI,kBAAA;IACA,uBAAA;ERoTJ;EQnTI;IACE,WAAA;ERqTN;AACF;AQnTI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;ARoTN;AExVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ERsTN;AACF;AQnTE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARoTJ;AExWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ERsTJ;EQrTI;IACE,WAAA;ERuTN;AACF;AQpTE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ARsTJ;AEtXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ERwTJ;AACF;AQtTE;EAEE,SAAA;EACA,eAAA;ARuTJ;;AA/XA;EACE,gCAAA;EACA,aAAA;EACA,kBAAA;AAkYF;AE9WE;EFvBF;IAMI,WAAA;IACA,UAAA;IACA,6BAAA;EAmYF;AACF;;AA7XE;EAEE,gCShBM;ETiBN,SAAA;EACA,aAAA;EACA,kBAAA;AA+XJ;AA5XI;EAEE,SAAA;EACA,mBAAA;AA6XN;AA3XM;EACE,kBAAA;AA6XR;AA3XQ;EACE,gFAAA;AA6XV;AEtYE;EFKI;IAQI,WAAA;EA6XR;EAlZA;IA2BI,SAAA;EA4XJ;AAJF","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"/src/assets/scss/\" as *;\n\n.main {\n  background-color: $dark-bg;\n  padding: 24px;\n  border-radius: 8px;\n\n  @include middleTablet {\n    width: 100%;\n    padding: 0;\n    background-color: transparent;\n  }\n}\n\n.container {\n  // @extend %flex-column;\n\n  &_fields {\n    @extend %flex-column;\n    background-color: $dark-bg;\n    gap: 20px;\n    padding: 25px;\n    border-radius: 8px;\n    \n\n    &_actions {\n      @extend %flex-align-start;\n      gap: 20px;\n      margin-top: 0.75rem;\n\n      button {\n        width: max-content;\n\n        &:hover:not([disabled]) {\n          background: linear-gradient($main-color, rgb(0 0 0/70%)) top/100% 900%;\n        }\n\n        @include middleTablet {\n          width: 100%;\n        }\n      }\n    }\n\n    @include middleTablet {\n      gap: 20px;\n    }\n  }\n\n  \n}\n","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__IdUBf`,
	"interface_heading_row": `style_interface_heading_row__akO-N`,
	"container_fields_actions": `style_container_fields_actions__7LzFa`,
	"interface_noResults": `style_interface_noResults__iamwN`,
	"container_fields": `style_container_fields__dIIaD`,
	"interface": `style_interface__9yc51`,
	"link": `style_link__2MFbX`,
	"text-gradient-intel": `style_text-gradient-intel__o+kAT`,
	"text-xs": `style_text-xs__WFoas`,
	"text-sm": `style_text-sm__x-48N`,
	"interface_heading": `style_interface_heading__hPMJY`,
	"interface_footer": `style_interface_footer__yI8m7`,
	"text-base": `style_text-base__XqD2Z`,
	"text-lg": `style_text-lg__ySmpK`,
	"text-xl": `style_text-xl__Ny5me`,
	"text-leading": `style_text-leading__8BN4+`,
	"breadcumb": `style_breadcumb__Umiqk`,
	"divider": `style_divider__L9PlY`,
	"badge": `style_badge__zaKJ-`,
	"xs": `style_xs__AzKov`,
	"sm": `style_sm__0a+9H`,
	"primary": `style_primary__tWUd9`,
	"pm": `style_pm__DVrQh`,
	"sd": `style_sd__+z0QT`,
	"Likely": `style_Likely__juAhP`,
	"Unvalidated": `style_Unvalidated__NAZEI`,
	"Verified": `style_Verified__IPic+`,
	"green": `style_green__TmRpn`,
	"off": `style_off__ALPA-`,
	"badgeTable": `style_badgeTable__M5T16`,
	"table": `style_table__B6epK`,
	"style-1": `style_style-1__i6woY`,
	"label": `style_label__2H+qg`,
	"noBorder": `style_noBorder__QwxU4`,
	"disabled": `style_disabled__r8uIk`,
	"active": `style_active__n2JD5`,
	"info": `style_info__0wzeD`,
	"interface_foot": `style_interface_foot__Pxu5p`,
	"main": `style_main__soj+g`
};
export default ___CSS_LOADER_EXPORT___;
